export const ANDROID = 'android';
export const IOS = 'ios';
export const EMBEDDED = 'embedded';
export const DESKTOP = 'desktop';
